var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_12_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0262 15.9126C61.4739 15.9126 62.6474 17.0861 62.6474 18.5338V22.2034C62.6474 23.651 61.4739 24.8245 60.0262 24.8245C58.5786 24.8245 57.4051 23.651 57.4051 22.2034V18.5338C57.4051 17.0861 58.5786 15.9126 60.0262 15.9126ZM60.0262 95.1763C61.4739 95.1763 62.6474 96.3498 62.6474 97.7975V101.467C62.6474 102.915 61.4739 104.088 60.0262 104.088C58.5786 104.088 57.4051 102.915 57.4051 101.467V97.7975C57.4051 96.3498 58.5786 95.1763 60.0262 95.1763ZM18.5071 57.3793C17.0595 57.3793 15.886 58.5528 15.886 60.0004C15.886 61.448 17.0595 62.6216 18.5071 62.6216H22.2292C23.6768 62.6216 24.8503 61.448 24.8503 60.0004C24.8503 58.5528 23.6768 57.3793 22.2292 57.3793H18.5071ZM95.2545 60.0004C95.2545 58.5528 96.4281 57.3793 97.8757 57.3793H101.493C102.941 57.3793 104.114 58.5528 104.114 60.0004C104.114 61.448 102.941 62.6216 101.493 62.6216H97.8757C96.4281 62.6216 95.2545 61.448 95.2545 60.0004ZM35.1439 88.5896C36.1675 87.566 36.1675 85.9064 35.1439 84.8828C34.1203 83.8591 32.4606 83.8591 31.437 84.8828L28.8683 87.4515C27.8447 88.4751 27.8447 90.1347 28.8683 91.1584C29.8919 92.182 31.5515 92.182 32.5752 91.1584L35.1439 88.5896ZM91.1842 28.8425C92.2078 29.8661 92.2078 31.5257 91.1842 32.5493L88.6154 35.1181C87.5918 36.1417 85.9322 36.1417 84.9086 35.1181C83.8849 34.0944 83.8849 32.4348 84.9086 31.4112L87.4773 28.8425C88.5009 27.8188 90.1605 27.8188 91.1842 28.8425ZM32.5752 28.8425C31.5515 27.8188 29.8919 27.8188 28.8683 28.8425C27.8447 29.8661 27.8447 31.5257 28.8683 32.5493L31.437 35.1181C32.4606 36.1417 34.1203 36.1417 35.1439 35.1181C36.1675 34.0944 36.1675 32.4348 35.1439 31.4112L32.5752 28.8425ZM84.9086 84.8828C85.9322 83.8591 87.5918 83.8591 88.6154 84.8828L91.1842 87.4515C92.2078 88.4751 92.2078 90.1347 91.1842 91.1584C90.1605 92.182 88.5009 92.182 87.4773 91.1584L84.9086 88.5896C83.8849 87.566 83.8849 85.9064 84.9086 84.8828ZM60 89.1389C76.0928 89.1389 89.1385 76.0932 89.1385 60.0004C89.1385 43.9077 76.0928 30.8619 60 30.8619C43.9073 30.8619 30.8615 43.9077 30.8615 60.0004C30.8615 76.0932 43.9073 89.1389 60 89.1389Z",
    fill: "url(#paint0_linear_12_1542)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_12_1542",
    x: 3.88599,
    y: 3.9126,
    width: 112.228,
    height: 112.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_1542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_1542",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_12_1542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_1542",
    x1: 60,
    y1: 15.9126,
    x2: 60,
    y2: 104.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF627C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDay);
export default __webpack_public_path__ + "static/media/clear_day.2d62042cd1f6049074a5b1cbfe719e8c.svg";
export { ForwardRef as ReactComponent };